import React from "react";
import Button from "@ds/components/Button";
import Text from "@ds/components/Text";
import { Box } from "@mui/material";
import useStyles from "../../styles";
import { useTranslation } from "next-i18next";

const CallUsPartial: React.FC = () => {
  const classes = useStyles({});
  const { t } = useTranslation("common");

  const handleContactUs = () => {
    window.open("https://wa.me/6281119678999", "_blank");
  };

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      width="100%"
      bgcolor="white"
      px="16px"
      pt="12px"
      pb="16px"
      boxShadow="0px -6px 12px rgba(46, 67, 77, 0.1)"
      className={classes.transitionFromBottom}
    >
      <Text
        variant="subtitle1"
        align="center"
        component="p"
        sx={{
          marginBottom: "12px",
          lineHeight: "22px",
        }}
      >
        {t("about.help")}
      </Text>
      <Button onClick={handleContactUs} fullWidth>{t("about.buttonInterest")}</Button>
    </Box>
  );
};

export default CallUsPartial;
